import React, { useEffect } from 'react'
import { Dispatch } from 'redux'
import {
  PhotoLibraryOutlined,
  AddBoxOutlined,
  FormatListNumbered,
} from '@material-ui/icons'
import { IGroupDetailed } from '../../types/group'
import { getGroupsDetailed } from '../../actions/groupsDetailed'
import { Main, Scrollable, SettingFormsWrapper } from '../../layouts'
import { CreateGroupForm } from '../../forms'
import {
  CombinedTitle,
  TabsHead,
  View,
  SettingsMenu,
  H2,
} from '../../components'
import { AllGroupsTab } from './AllGroupsTab'
import { ReorderGroupsTab } from './ReorderGroupsTab'

export interface IPublishingGroupsManagementPage {
  groupsList: IGroupDetailed[]
  groupsLoading: boolean
  groupsLoaded: boolean
  canViewCreateGroupPage: boolean
  canViewReorderGroupsPage: boolean
  dispatch: Dispatch
}

export const PublishingGroupsManagementPage = ({
  groupsList,
  groupsLoading,
  groupsLoaded,
  canViewCreateGroupPage,
  canViewReorderGroupsPage,
  dispatch,
}: IPublishingGroupsManagementPage) => {
  useEffect(() => {
    if (!groupsLoading && !groupsLoaded) {
      dispatch(getGroupsDetailed())
    }
  }, [dispatch, groupsLoaded, groupsLoading])
  return (
    <Main
      sidebarSecondary={<SettingsMenu />}
      titleBlock={
        <>
          <CombinedTitle first="Publishing Groups" second="Management" />
          <TabsHead
            tabs={[
              {
                label: 'All groups',
                value: 'groups',
                icon: <PhotoLibraryOutlined />,
              },
              ...(canViewCreateGroupPage
                ? [
                    {
                      label: 'Create',
                      value: 'create',
                      icon: <AddBoxOutlined />,
                    },
                  ]
                : []),
              ...(canViewReorderGroupsPage
                ? [
                    {
                      label: 'Reorder',
                      value: 'reorder',
                      icon: <FormatListNumbered />,
                    },
                  ]
                : []),
            ]}
          />
        </>
      }
      helmet="Administration: Publishing Groups"
    >
      <Scrollable>
        <View tab="groups">
          <H2 ml={2}>Publishing groups</H2>
          {groupsList.length > 0 && <AllGroupsTab groupsList={groupsList} />}
        </View>
        {canViewCreateGroupPage && (
          <View keep tab="create">
            <SettingFormsWrapper>
              <CreateGroupForm />
            </SettingFormsWrapper>
          </View>
        )}
        {canViewReorderGroupsPage && (
          <View tab="reorder">
            <H2 ml={2}>Drag groups to reorder</H2>
            {groupsList.length > 0 && <ReorderGroupsTab />}
          </View>
        )}
      </Scrollable>
    </Main>
  )
}
